import fetch from './fetch'

class RevisitApi {
	public getList(form: any) {
		return fetch({
			url: 'injury/revisit/list',
			method: 'post',
			data: form,
		})
	}
	public wholeprocess(form: any) {
		return fetch({
			url: 'injury/wholeprocess/order/list',
			method: 'post',
			data: form,
		})
	}

	public getDetail(id: string) {
		return fetch({
			url: 'injury/revisit/detail',
			params: {
				id,
			},
		})
	}

	public begin(id: string) {
		return fetch({
			url: 'injury/revisit/begin',
			params: {
				id,
			},
		})
	}

	public cancel(id: string) {
		return fetch({
			url: 'injury/revisit/cancel',
			params: {
				id,
			},
		})
	}

	public save(form: any) {
		return fetch({
			url: 'injury/revisit/save',
			method: 'post',
			data: form,
		})
	}

	public exportList(form: any) {
		return fetch({
			url: 'injury/revisit/export',
			method: 'post',
			data: form,
			responseType: 'blob',
			timeout: 0,
		})
	}

	public exportPDF(id: string) {
		return fetch({
			url: 'injury/revisit/detail/exportpdf',
			params: {
				id,
			},
			responseType: 'blob',
			timeout: 0,
		})
	}

	public getQuestionnaireList(form: any) {
		return fetch({
			url: 'injury/questionnaire/template/list',
			method: 'post',
			data: form,
		})
	}

	public saveQuestionnaire(form: any) {
		return fetch({
			url: 'injury/questionnaire/template/save',
			method: 'post',
			data: form,
		})
	}

	public getQuestionList(form: any) {
		return fetch({
			url: 'injury/questionnaire/question/list',
			method: 'post',
			data: form,
		})
	}

	public getTemplateDetail(templateId: string) {
		return fetch({
			url: 'injury/questionnaire/template/detail',
			method: 'get',
			params: {
				templateId,
			},
		})
	}

	public getPendingDetail(id: string) {
		return fetch({
			url: 'injury/revisit/trackTaskDetail',
			method: 'get',
			params: {
				id,
			},
		})
	}

	public changeTemplateStatus(templateId: string) {
		return fetch({
			url: 'injury/questionnaire/template/changeStatus',
			method: 'get',
			params: {
				templateId,
			},
		})
	}

	public deleteTemplate(templateId: string) {
		return fetch({
			url: 'injury/questionnaire/template/delete',
			method: 'get',
			params: {
				templateId,
			},
		})
	}

	public saveTrackTask(form: any) {
		return fetch({
			url: 'injury/revisit/saveTrackTask',
			method: 'POST',
			data: form,
		})
	}

	public addTrackTask(orderId: string) {
		return fetch({
			url: 'injury/revisit/addTrackTask',
			method: 'GET',
			params: {
				orderId,
			},
		})
	}

	public saveRemark(form: any) {
		return fetch({
			url: 'injury/revisit/editTrackRemark',
			method: 'POST',
			params: form,
		})
	}

	public notifyInsurance(revisitId: string) {
		return fetch({
			url: 'injury/revisit/notifyInsurance',
			method: 'GET',
			params: {
				revisitId,
			},
		})
	}

	public addQuestion(form: any) {
		return fetch({
			url: 'injury/questionnaire/question/add',
			method: 'POST',
			data: form,
		})
	}

	public updateQuestion(form: any) {
		return fetch({
			url: 'injury/questionnaire/question/edit',
			method: 'POST',
			data: form,
		})
	}

	public removeQuestionCheck(id: string) {
		return fetch({
			url: 'injury/questionnaire/question/remove/check',
			method: 'POST',
			data: {
				questionId: id,
			},
		})
	}

	public removeQuestion(id: string) {
		return fetch({
			url: 'injury/questionnaire/question/remove',
			method: 'POST',
			data: {
				questionId: id,
			},
		})
	}

	public getAuditList(form: any) {
		return fetch({
			url: 'injury/check/order/list',
			method: 'post',
			data: form,
		})
	}

	public exporAuditList(form: any) {
		return fetch({
			url: 'injury/check/order/excel',
			method: 'post',
			data: form,
			responseType: 'blob',
			timeout: 0,
		})
	}

	public claim(orderId: string, recordType: string, force: string) {
		return fetch({
			url: 'injury/check/order/claim',
			method: 'GET',
			params: {
				orderId,
				recordType,
				force,
			},
		})
	}
}

export default new RevisitApi()
